import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonInfiniteScroll } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { product } from 'src/app/models/interfaces';
import { AuthService } from 'src/app/services/auth.service';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-catalog3d',
  templateUrl: './catalog3d.component.html',
  styleUrls: ['./catalog3d.component.scss'],
})
export class Catalog3dComponent implements OnInit {

  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  path = 'productos';
  productos: product[] = [];
  buscar: string = '';
  load: any;
  nuevosSuscriber: Subscription;
  disablescroll: boolean = false;
  filters: any[] = [];
  promociones: boolean = false;
  todo: boolean = false;
  limit: any;
  category: string;
  tienda: string = 'tienda';

  // género tal como viene en la ruta: 'mujeres' | 'hombres' | ...
  // coincide con los valores del array gender en Firestore
  gender: string;

  order: any;

  constructor(
    private firestore: FirestoreService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) {}

  formFilter = this.fb.group({
    filter: [null],
  });

  ngOnInit(): void {
    // Leer el género de la ruta PRIMERO
    this.gender = this.route.snapshot.params['genero']; // ej: 'mujeres'

    this.getFiltersValue();
    this.firestore.category = 'todo';
    this.category = 'todo';
    this.firestore.primero = true;
    this.firestore.order = 'desc';

    // Una sola carga inicial
    this.getProductFilter('date');
    this.ordenar();
  }

  resetSearch(e) {
    if (e.detail.value == '') {
      this.search(e.detail.value);
    }
  }

  async search(q: string) {
    this.productos = [];
    this.firestore.search(q.toLocaleLowerCase(), this.gender).subscribe(res => {
      if (res.length > 0) {
        res.forEach(pedido => {
          if (!this.productos.find(prod => prod['id'] === pedido['id'])) {
            this.productos.push(pedido);
          }
        });
      }
    });
  }

  getProductFilter(orden) {
    this.path = 'productos';
    let startAt = null;
    if (this.productos.length) {
      switch (orden) {
        case 'date':
          startAt = this.productos[this.productos.length - 1].date;
          break;
        case 'price':
          startAt = this.productos[this.productos.length - 1].price;
          break;
      }
    }

    // gender es array en Firestore → array-contains con el valor plural de la ruta
    this.nuevosSuscriber = this.firestore.getCollectionProductos(
      this.path,
      'gender',
      '==',         // parámetro de firma, internamente usa array-contains
      this.gender,  // 'mujeres' | 'hombres' — coincide con Firestore
      'style',
      '3d',
      orden,
      startAt
    ).subscribe(res => {
      if (res.length > 0) {
        res.forEach(pedido => {
          if (!this.productos.find(prod => prod['id'] === pedido['id'])) {
            this.productos.push(pedido);
          }
        });
      } else {
        this.disablescroll = true;
      }
    });
  }

  cargarMAs() {
    let orderby: any = {};
    if (!this.formFilter.get('filter').value) {
      orderby['value'] = 'date';
    } else {
      orderby = this.formFilter.get('filter').value;
    }
    this.promociones
      ? this.getPromociones(orderby.value)
      : this.getProductFilter(orderby.value);
    this.infiniteScroll.complete();
  }

  getFiltersValue() {
    this.firestore.getCollection('orderby/').subscribe(res => {
      this.filters = res;
    });
  }

  filterCateogry(e) {
    this.firestore.primero = true;
    this.promociones = e.name === 'promociones';

    if (e.name === 'todo') {
      this.firestore.category = null;
      this.firestore.primero = true;
    }

    this.category = e.name;
    this.productos = [];
    this.disablescroll = false;

    let orderby: any = {};
    if (this.formFilter.get('filter').value) {
      orderby = this.formFilter.get('filter').value;
      if (orderby.order === 'mayor') {
        this.firestore.mayor = true;
      }
    } else {
      orderby.value = 'date';
    }

    if (orderby.order === 'menor') {
      this.firestore.primero = true;
      this.firestore.order = 'asc';
    } else {
      this.firestore.primero = true;
      this.firestore.order = 'desc';
    }

    this.firestore.category = e.name;

    if (e.name === 'promociones') {
      this.getPromociones(orderby.value);
    } else {
      this.getProductFilter(orderby.value);
    }
  }

  ordenar() {
    this.formFilter.controls['filter'].valueChanges.subscribe(orderby => {
      this.order = orderby.order;
      if (orderby.order === 'menor') {
        this.firestore.primero = true;
        this.firestore.order = 'asc';
      } else {
        this.firestore.order = 'desc';
      }
      this.productos = [];
      this.disablescroll = false;
      this.promociones
        ? this.getPromociones(orderby.value)
        : this.getProductFilter(orderby.value);
    });
  }

  filterMayor(e) {
    this.firestore.primero = true;
    this.promociones = e.name === 'promociones';

    if (e.name === 'todo') {
      this.firestore.category = null;
      this.firestore.primero = true;
    }

    this.category = e.name;
    this.productos = [];

    let orderby: any = {};
    if (this.formFilter.get('filter').value) {
      orderby = this.formFilter.get('filter').value;
    } else {
      orderby.value = 'date';
    }

    if (orderby.order === 'menor') {
      this.firestore.primero = true;
      this.firestore.order = 'desc';
    }

    this.firestore.category = e.name;

    if (e.name === 'promociones') {
      if (orderby.order === 'menor') {
        this.firestore.primero = true;
        this.firestore.order = 'desc';
      }
      this.getPromociones(orderby.value);
    } else if (e.name === 'todo') {
      if (orderby.order === 'menor') {
        this.firestore.primero = true;
        this.firestore.order = 'desc';
      }
      this.getProductFilter('date');
    } else {
      this.getProductFilter(orderby.value);
    }

    this.disablescroll = false;
  }

  getPromociones(orden) {
    this.disablescroll = false;
    let startAt = null;
    if (this.productos.length) {
      switch (orden) {
        case 'date':
          startAt = this.productos[this.productos.length - 1].date;
          break;
        case 'price':
          startAt = this.productos[this.productos.length - 1].price;
          break;
      }
    }

    this.firestore.getPromociones(
      this.path,
      'gender',
      '==',
      this.gender,  // 'mujeres' | 'hombres'
      orden,
      startAt
    ).subscribe(res => {
      if (res.length > 0) {
        res.forEach(producto => {
          if (!this.productos.find(prod => prod['id'] === producto['id'])) {
            this.productos.push(producto);
          }
        });
      } else {
        this.disablescroll = true;
      }
    });
  }

  getTodo(orden) {
    this.getProductFilter('date');
  }
}
